export default "__VITE_ASSET__Ca_z_VBT__"